export default function ({ store, redirect, route }) {
    if (!store.state?.application?.driver?.authUser) {
        let path = '/nfts/products';
        if (route.query.ref) {
            path += `?ref=${route.query.ref}`;
        }
        return redirect(path);
    }
}
